<template>
    <div class="wrapper landing-page">        
        <div class="section padding-top section-about-us">
            <div class="container">
                    <div class="row top-padding">
                        <div class="col-md-6">
                            <card type="blog" plain>
                                <a :href="TopLeftLink" target="_blank">
                                   <img slot="image" class="img rounded img-raised" :src="TopLeft"/>
                                </a>
                            </card>
                        </div>
                        <div class="col-md-6">
                            <card type="blog" plain>
                                <a :href="TopRightLink" target="_blank">
                                   <img slot="image" class="img rounded img-raised" :src="TopRight"/>
                                </a>
                            </card>
                        </div>
                    </div>
                <div class="row">
                    <div class="col-md-8">
                        <h3 class="title">Latest Predictions</h3>
                        <card v-for='prediction in predictions' :key="prediction.id" type="blog" plain>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="card-image">
                                        <img class="img img-raised rounded" :src="prediction.picture" />
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h3 class="card-title">
                                    <router-link v-bind:to="{name: 'Prediction-Detail-Home', params: { item_id: prediction.id }}">
                                     {{prediction.title}}
                                    </router-link>
                                    </h3>
                                    <p class="card-description">
                                       {{prediction.content}}
                                    </p>
                                </div>
                            </div>
                        </card>
                        <!-- Australia Reviews -->
                        <h3 class="title">Australia Reviews</h3>
                        <div class="row">
                            <div v-for='review in australiaReviews' :key="review.id" class="col-md-6">
                                <div class="card card-blog">
                                    <div class="card-image">
                                         <router-link v-bind:to="{name: 'review-detail-au-home', params: { item_id: review.id }}">
                                             <img class="img rounded" :src="review.logo"> 
                                        </router-link>
                                    </div>
                                    <div class="card-body">
                                        <!-- <h6 class="category text-primary">Features</h6>
                                        <h5 class="card-title">
                                            That’s One Way To Ditch Your Passenger
                                        </h5> -->
                                        <p class="card-description">
                                            {{review.content}}
                                        </p>

                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point1}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point2}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point3}}
                                            </div>
                                        </div>
                                        

                                        <div class="card-footer">
                                            <a :href="review.buttonLink" target="_blank" class="btn-block btn btn-primary" >
                                            {{review.button}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Austalia Reviews End -->
                        <!-- USA Reviews -->
                        <h3 class="title">USA Reviews</h3>
                        <div class="row">
                            <div v-for='review in usaReviews' :key="review.id" class="col-md-6">
                                <div class="card card-blog">
                                    <div class="card-image">
                                        <router-link v-bind:to="{name: 'review-detail-us-home', params: { item_id: review.id }}">
                                             <img class="img rounded" :src="review.logo"> 
                                        </router-link>
                                    </div>
                                    <div class="card-body">
                                        <!-- <h6 class="category text-primary">Features</h6>
                                        <h5 class="card-title">
                                            That’s One Way To Ditch Your Passenger
                                        </h5> -->
                                        <p class="card-description">
                                            {{review.content}}
                                        </p>

                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point1}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point2}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2">
                                                <div class="icon icon-primary">
                                                    <i class="far fa-check-circle"></i>
                                                 </div>
                                            </div>
                                            <div class="col-10">
                                               {{review.point3}}
                                            </div>
                                        </div>


                                        <div class="card-footer">
                                            <a :href="review.buttonLink" target="_blank" class="btn-block btn btn-primary" >
                                            {{review.button}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- USA Review -->


                    </div>
                    <!-- SIDEBAR BEGINS -->
                    <div class="col-md-4">
                       <sidebar></sidebar>
                    </div>
                    <!-- SIDEBAR ENDS -->
                </div>


            </div>
        </div>
             <modal :show.sync="$store.state.models.modalClasic" headerClasses="justify-content-center" type="mini">
                <h4 slot="header" class="title title-up">Success!</h4>
                <p>You have succesfully registered! thank you for choosing us</p>
                <template slot="">
                  <n-button class="btn btn-block"  type="primary" @click.native="$store.state.models.modalClasic = false">OK</n-button>
                  <!-- <n-button @click.native="$store.state.models.modalClasic = false">Close</n-button> -->
                </template>
              </modal>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Tabs, TabPane, Modal } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import db from '../../components/Firebase/firebaseInit'
  import Sidebar from '@/pages/bet/sidebar';

  export default {
    name: 'landing-page',
    bodyClass: 'landing-page',
    components: {
      Card,
      Tabs,
      TabPane,
      Modal,
      Sidebar,
      [Button.name]: Button,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        bestUsBettingSites: [],
        bestAustraliaBettingSites: [],
        australiaReviews: [],
        usaReviews: [],
        predictions: [],
        TopRight: null,
        TopLeft: null,
        RightOne: null,
        RightTwo: null,
        form: {
          firstName: '',
          email: '',
          message: ''
        }
      }
    },
    created(){
    db.collection('usaReviews').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'logo': doc.data().logo,
          'content': doc.data().content,
          'point1': doc.data().point1,
          'point2': doc.data().point2,
          'point3': doc.data().point3,
          'button': doc.data().button,
          'buttonLink': doc.data().buttonLink
        }
        this.usaReviews.push(data)
      })
    })
    db.collection('latestPredictionHome').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'picture': doc.data().picture,
          'title': doc.data().title,
          'content': doc.data().content
        }
        this.predictions.push(data)
      })
    })
    db.collection('australiaReviews').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'logo': doc.data().logo,
          'content': doc.data().content,
          'point1': doc.data().point1,
          'point2': doc.data().point2,
          'point3': doc.data().point3,
          'button': doc.data().button,
          'buttonLink': doc.data().buttonLink
        }
        this.australiaReviews.push(data)
      })
    })
    db.collection('homepageBanners').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        if(doc.data().name == 'TopRight'){
            this.TopRight = doc.data().link;
            this.TopRightLink = doc.data().imgLink
        }else if(doc.data().name == 'TopLeft'){
            this.TopLeft = doc.data().link;
            this.TopLeftLink = doc.data().imgLink
        }else if(doc.data().name == 'RightOne'){
            this.RightOne = doc.data().link;
        }else if(doc.data().name == 'RightTwo'){
            this.RightTwo = doc.data().link;
        }
      })
    })

    }
  }
</script>
<style scoped>
.padding-top{
    padding: 105px 0 !important;
}
.mar-10{
    margin-left: 15px
}
</style>
